<template>
  <div class="id-card-upload">
    <Progress progress="17"></Progress>
    <div class="step-box">
      <p class="title">{{ $t('openAccount.t000041') }}</p>

      <div class="tips-box">
        <p class="title">{{ $t('openAccount.t000042') }}</p>
        <p class="text">{{ $t('openAccount.t000043') }}</p>
        <!--      <p class="text">{{ $t('openAccount.t000044') }}<span>{{ $t('openAccount.t000045') }}</span>；</p>-->
        <!--      <p class="text">{{ $t('openAccount.t000046') }}</p>-->
      </div>
      <div class="eg-box">
        <p class="title">{{ $t('openAccount.t000047') }}</p>
        <div class="list">
          <template v-if="process_id == 1">
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-cn-01.png" />
              <p class="text">{{ $t('openAccount.t000048') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-cn-02.png" />
              <p class="text">{{ $t('openAccount.t000049') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-cn-03.png" />
              <p class="text">{{ $t('openAccount.t000050') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-cn-04.png" />
              <p class="text">{{ $t('openAccount.t000051') }}</p>
            </div>
          </template>
          <template v-if="process_id == 2">
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-hk-01.png" />
              <p class="text">{{ $t('openAccount.t000048') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-hk-02.png" />
              <p class="text">{{ $t('openAccount.t000049_1') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-hk-03.png" />
              <p class="text">{{ $t('openAccount.t000050') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-hk-04.png" />
              <p class="text">{{ $t('openAccount.t000051_1') }}</p>
            </div>
          </template>
          <template v-if="process_id == 3">
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-other-01.png" />
              <p class="text">{{ $t('openAccount.t000048') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-other-02.png" />
              <p class="text">{{ $t('openAccount.t000049_2') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-other-03.png" />
              <p class="text">{{ $t('openAccount.t000050') }}</p>
            </div>
            <div class="item">
              <img class="icon" src="@/assets/images/open-account/eg-other-04.png" />
              <p class="text">{{ $t('openAccount.t000051') }}</p>
            </div>
          </template>
        </div>
      </div>
      <div class="upload-box" :class="{ ani: showUploadAni }">
        <div class="item">
          <!-- 首次认证 直接调取第三方 -->
          <div v-if="!isUploaded && !positiveImg.base64_content" class="mask" @click="toFeceCheck"></div>
          <UploadImg
            :icon="beforeIcon"
            :text="beforeIconText[0]"
            :img="positiveImg.base64_content" 
            accept="image/jpeg"
            @afterRead="afterRead"
            @del="delImg"
          />
        </div>
        <!--        大陆才有反面 -->
        <div v-if="process_id == 1" class="item">
          <!-- 首次认证 直接调取第三方 -->
          <div v-if="!isUploaded && !positiveImg.base64_content" class="mask" @click="toFeceCheck"></div>
          <UploadImg
            :icon="afterIcon"
            :text="beforeIconText[1]"
            :img="inverseImg.base64_content"
            accept="image/jpeg"
            @afterRead="afterRead2"
            @del="delImg2"
          />
        </div>
      </div>
    </div>

    <NavButtons @on-next="next" />
    <!--    失败弹窗 -->
    <van-popup
      :class="['is-error-popup', bgColor == 'black-theme' ? 'darkOrLight':'upload-img-error']"
      v-model="showErrorDialog"
      :message="$t('openAccount.t000054')"
      :title="$t('openAccount.t000055')"
    >
      <div class="is-error-main">
        <p class="tip">{{ $t('openAccount.t000055') }}</p>
        <p class="message">{{ $t('openAccount.t000054') }}</p>
        <div class="btn-box">
<!--          <Uploader-->
<!--            class="btn"-->
<!--            accept="image/jpeg"-->
<!--            capture="user"-->
<!--            :after-read="afterRead"-->
<!--          >-->
<!--            <span>{{ $t("openAccount.t000052") }}</span>-->
<!--          </Uploader>-->
          <UploadImg
            class="btn"
            :text="$t('openAccount.t000052')"
            :img="positiveImg.base64_content"
            accept="image/jpeg"
            @afterRead="afterRead"
            @del="delImg"
          >
            <template #custom>
              <span>{{ $t("openAccount.t000052") }}</span>
            </template>
          </UploadImg>
          <div class="btn" @click="confirm">{{ $t('openAccount.t000053') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Progress from "../components/Progress.vue";
import NavButtons from "../components/navButtons.vue";
import UploadImg from "../components/UploadImg.vue";
import beforeIcon from "@/assets/images/id-card-upload-before.png";
import afterIcon from "@/assets/images/id-card-upload-after.png";
import { Popup, Toast, Uploader } from "vant";
import moment from "moment/moment";
import pinyin from "pinyin";
import { getBrowser } from "@/utils/browser";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";

export default {
  name: "IdCardUpload",
  components: {
    Uploader,
    Progress,
    NavButtons,
    UploadImg,
    [Popup.name]: Popup,
  },
  computed: {
    beforeIconText() {
      if(!this.process_id) return  ''
      const text = {
        2: [this.$t('openAccount.t000133'), this.$t('openAccount.t000134')],
        1: [this.$t('openAccount.t000057'), this.$t('openAccount.t000058')],
        3: [this.has_local_id == 1 ? this.$t('openAccount.t000180') : this.$t('openAccount.t000059')]
      };
      return text[this.process_id];
    },
    canNext() {
      const { process_id } = this;
      let check = this.positiveImg.card_img;
      if (process_id == 1) {
        check = this.positiveImg.card_img && this.inverseImg.card_img;
      }
      return check;
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  data() {
    return {
      beforeIcon,
      afterIcon,
      configData: "", // 当前页面的数据
      process_id: "", // 1 大陆 2香港  3 其他    2 3 人脸识别  1 ocr图片验证 + 后续上传视频
      has_local_id: 0, // 2-2 config_data 内的字段，process_id=3 时生效
      isUploaded: 0, // 0 去第三方人脸识别iframe 1 直接拉起本地上传
      showErrorDialog: false,
      showUploadAni: false,
      positiveImg: {
        type: 1,
        card_img: "", // 图片的服务端地址
        base64_content: "" // base64文件
      }, // 正面
      inverseImg: {
        type: 0,
        card_img: "", // 图片的服务端地址
        base64_content: "" // base64文件
      }, // 反面  大陆才有反面
      ocrData: [] // ocr识别的数据  如果有了 点击next的时候 不需要重新调取我们自己平台的ocr的
    };
  },
  created() {
    if(getBrowser().isApp){
      setStatementDetailInfo({
        headerTitle: this.$route.meta.title,
        hideTitle: '0'
      })
    }
    const { response, bizId, change } = this.$route.query;
    this.isUploaded = change == 1 ? 1 : 0;
    if (response) {
      this.isUploaded = 1;
      // 调PHP接口 查看结果
      const loading = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis
        .getZolozCheckResultApi({ bizId, action_module: 'ocr' })
        .then(res => {
          const { result, extInfo } = res;
          
          // 大陆 拿 base64
          if (result.resultCode == "SUCCESS") {
            this.positiveImg.card_img = extInfo.imageContent_url[0];
            this.positiveImg.base64_content =
              "data:image/png;base64," + extInfo.imageContent[0];
            this.inverseImg.card_img = extInfo.imageContent_url[1];
            this.inverseImg.base64_content =
              "data:image/png;base64," + extInfo.imageContent[1];
            const { ocrResult } = extInfo;
            
            if (ocrResult) {
              if(this.process_id == 1){
                this.ocrData = [
                  {
                    ocr: {
                      birth: ocrResult?.DOB,
                      address: ocrResult?.PLACE_OF_PERMANENT,
                      name: ocrResult.FULL_NAME,
                      sex: ocrResult?.SEX,
                      num: ocrResult?.ID_NUMBER
                    }
                  },
                  {
                    ocr: {
                      start_date: ocrResult?.EXPIRY_DATE?.split("-")?.[0],
                      end_date: ocrResult?.EXPIRY_DATE?.split("-")?.[1]
                    }
                  }
                ];
              }
              else if(this.process_id == 2){
                
                this.ocrData = [
                  {
                    ocr: {
                      birth: ocrResult?.DATE_OF_BIRTH,
                      name: ocrResult.NAME_CN,
                      sex: ocrResult?.SEX == 'M' ? '男' : '女',
                      num: ocrResult?.ID_NUMBER,
                      name_en:ocrResult?.NAME //香港英文
                    }
                  },
                  {
                    ocr: {
                      start_date: '',
                      end_date: ''
                    }
                  }
                ];
              }
              else if(this.process_id == 3){
                this.ocrData = [
                  {
                    ocr: {
                      birth: ocrResult?.DATE_OF_BIRTH,
                      name:  ocrResult?.FIRST_NAME + ' ' + ocrResult.LAST_NAME,
                      sex: ocrResult?.SEX == 'M' ? '男' : '女',
                      num: ocrResult?.ID_NUMBER
                    }
                  },
                  {
                    ocr: {
                      start_date: '',
                      end_date: ocrResult?.EXPIRY_DATE ? moment(ocrResult?.EXPIRY_DATE).format("YYYY-MM-DD") : ''
                    }
                  }
                ];
              }
            }else{
              this.ocrData = [];
            }
            loading.clear()
            this.next();
          } else {
            
            this.ocrData = [];
            this.showErrorDialog = true;
          }
        })
        .catch(err => {
          
          this.showErrorDialog = true;
        });
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$apis.accountSituationV2({
        step_code: "1,3-1,2-2",
      }).then(res => {
        if (res?.process_info) {
          this.process_id = res?.process_info?.["1"]?.process_id || res?.get_open_account_info?.open_status;
          const config_data_2_2 = res?.process_info?.["2-2"]?.config_data;
          if (config_data_2_2) {
            const parsed_2_2 = JSON.parse(config_data_2_2);
            this.has_local_id = parsed_2_2?.has_local_id ?? 0;
          }
          let config_data = res?.process_info?.["3-1"]?.config_data;
          if (config_data && JSON.stringify(config_data) != "{}") {
            config_data = JSON.parse(config_data);
            
            this.positiveImg.card_img = config_data.positive_img;
            this.positiveImg.base64_content = config_data.positive_img_base64;
            if (this.process_id == 1 || this.process_id == 2) {
              this.inverseImg.card_img = config_data.inverse_img;
              this.inverseImg.base64_content = config_data.inverse_img_base64;
            }
            this.configData = config_data;
          }
        }
      });
    },
    toFeceCheck() {
      const call = ()=>{
        if (!this.isUploaded) {
          const { origin, pathname } = window.location;
          
          const types = {
            1: 0,
            2: 1,
            3: this.has_local_id == 1 ? 3 : 2
          }
          this.$apis
            .zolozInitializeApi({
              completeCallbackUrl: origin + pathname,
              interruptCallbackUrl: origin + pathname,
              type: types[this.process_id],
              action_module: 'ocr'
            })
            .then(res => {
              // eslint-disable-next-line prefer-const
              let { h5Url, langPack } = res;
              const clientCfg = encodeURIComponent(res.clientCfg);
              let url = `${h5Url}?clientcfg=${clientCfg}`;
              if(getBrowser().isApp){
                setStatementDetailInfo({
                  headerTitle: this.$route.meta.title,
                  hideTitle: '1'
                })
              }
              if(langPack){
                langPack = encodeURIComponent(langPack);
                url = `${url}&langPack=${langPack}`
              }
              window.location.replace(url);
            }).catch(err => {
              this.isUploaded = 1;
              const message = this.$t('network_error_text.t00007');
              this.$toast({
                message,
                duration: 1000,
                onClose: () => {
                  this.ocrData = [];
                  this.showErrorDialog = true;
                }
              })

          });
        }
      }
      if(getBrowser().isApp){
        this.$JsBridge.callHandler('cameraPermissions', '', (res) => {
          
          if (res == true || res == 'true') {
            call();
          }else {
            this.$toast(this.$t('openAccount.t000137'))
          }
        })
      }else{
        call()
      }
    },
    afterRead(res) {
      this.showErrorDialog = false;
      this.positiveImg.card_img = res.content;
      this.positiveImg.base64_content = res.base64;
      // 上传了
      this.uploadDelImg();
    },
    delImg() {
      this.positiveImg.card_img = "";
      this.positiveImg.base64_content = "";
      // 通知服务端删除照片 不然下一次还是这个图的
      this.uploadDelImg();
    },
    afterRead2(res) {
      this.inverseImg.card_img = res.content;
      this.inverseImg.base64_content = res.base64;
      // 上传了
      this.uploadDelImg();
    },
    delImg2() {
      this.inverseImg.card_img = "";
      this.inverseImg.base64_content = "";
      this.uploadDelImg();
    },
    uploadDelImg() {
      setTimeout(()=>{
        const loading2 = Toast.loading({
          // mask: true, //蒙层
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: this.$t("common.uploading_text")
        });
        // 上传-删除 都要提交到服务端 防止刷新 图片丢失
        const params = {
          process_id: this.process_id,
          step_code: "3-1",
          step_order: 3,
          config_data: {
            ...this.configData,
            positive_img: this.positiveImg.card_img,
            positive_img_base64: this.positiveImg.base64_content,
            inverse_img: this.inverseImg.card_img,
            inverse_img_base64: this.inverseImg.base64_content
          }
        };
        this.$apis.supplementSaveApi(params).finally(() => {
          loading2.clear();
        })
      },20)
    },
    setNamePinyin(name) {
      const pinyinArr = pinyin(name, { style: pinyin.STYLE_NORMAL });
      const res = pinyinArr.map(item => {
        return item?.[0];
      });
      return res.join(" ");
    },
    isValidDate(dateStr) {
      return !isNaN(dateStr);
    },
    async next() {
      if (!this.canNext) {
        Toast({
          message: this.$t('openAccount.t000060')
        });
        return false;
      }
      const loading = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      const toNext = () => {
        this.$router
          .push({
            path: "/open-account/id-card-confirm",
            query: {
              ...this.$route.query
            }
          })
          .finally(() => {

          });
      }

      if(this.positiveImg.base64_content == this.configData.positive_img_base64){
        toNext();
        loading.clear();
        return ;
      }
      // 提交参数
      const params = {
        process_id: this.process_id,
        step_code: "3-1",
        step_order: 3,
        config_data: {
          bizId: this.$route.query.bizId,
          positive_img: this.positiveImg.card_img,
          positive_img_base64: this.positiveImg.base64_content,
          inverse_img: this.inverseImg.card_img,
          inverse_img_base64: this.inverseImg.base64_content
        }
      };
      //   大陆才有证件识别

      //   识别两次 正面+反面
      if(this.process_id == 1){
        // 修改资料的情况下不调用ocr
        if ((!this.ocrData || this.ocrData.length <= 0) && this.$route.query.change != 1) {
          const all = [this.ocr(1), this.ocr(0)];
          try {
            this.ocrData = await Promise.all(all);
          }catch (e) {

          }
        }
      }
      if (!this.ocrData?.[0]?.ocr) {
        this.ocrData[0] = {};
        this.ocrData[0].ocr = {
          birth: "",
          address: "",
          name: "",
          sex: "",
          num: ""
        };
      }
      const { birth, address, name, sex, num, name_en } = this.ocrData?.[0]?.ocr || {};

      let grepAddress = {};
      if (address) {
        try {
          grepAddress = await this.$apis.grepAddress({ address });
        }catch (e) {

        }
      }
      params.config_data = {
        ...params.config_data,
        birth: birth ? moment(birth).format("YYYY-MM-DD") : "",
        detail_address: grepAddress.address,
        country_name: grepAddress.area,
        country_code: grepAddress.country_code,
        city_name: grepAddress.city,
        city_code: grepAddress.city_code,
        province_name: grepAddress.province,
        province_code: grepAddress.province_code,
        real_name: name,
        english_name: this.process_id == 2 ? name_en : this.setNamePinyin(name),
        id_card: num,
        sex: sex ? (sex == "男" ? 1 : 2) : ""
      };
      if (!this.ocrData?.[1]?.ocr) {
        this.ocrData[1] = {};
        this.ocrData[1].ocr = {
          start_date: "",
          end_date: ""
        };
      }
      const { start_date, end_date } = this.ocrData?.[1]?.ocr;
      params.config_data = {
        ...params.config_data,
        end_date: this.isValidDate(end_date)
          ? moment(end_date).format("YYYY-MM-DD")
          : end_date,
        start_date: start_date ? moment(start_date).format("YYYY-MM-DD") : ""
      };

      this.$apis.supplementSaveApi(params).then(() => {

        if(this.$route.query.response){
          
          // 把地址重置 不然下一次进入页面 又是带了 back信息的 导致一直拉起认证
          this.$router
            .replace({
              path: "/open-account/id-card-upload"
            })
            .finally(() => {
              toNext();
              loading.clear();
            });
        }else{
          toNext();
          loading.clear();
        }
      });
    },
    // 证件识别 type 1正面 0反面
    async ocr(type = 0) {
      let params = {
        type,
        card_img: this.inverseImg.card_img,
        base64_content: this.inverseImg.base64_content
      };
      if (type == 1) {
        params = {
          type,
          card_img: this.positiveImg.card_img,
          base64_content: this.positiveImg.base64_content
        };
      }
      return new Promise((resolve, reject) => {
        this.$apis
          .ocrIdCardPhoto(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            resolve(err);
          });
      });
    },
    confirm() {
      this.isUploaded = false;
      this.toFeceCheck();
    },
    cancel() {
      this.isUploaded = true;
      this.showUploadAni = true;
    }
  }
};
</script>

<style lang="less" scoped>
.is-error-popup{
  background: #ffffff;
  border-radius: 32px;
  width: 600px;
  text-align: center;
  &.van-popup{
    p{
      color: #17161c;
    }
    .is-error-main{
      padding: 45px;
      .tip{
        font-size: 36px;
        font-weight: 500;
      }
      .message{
        margin-top: 32px;
        color: #747377;
        font-size: 32px;
      }
      .btn-box{
        display: flex;
        margin-top: 40px;
        .btn{
          flex: 1;
          color: #17161C;
          height: 104px;
          line-height: 104px;
          border-radius: 104px;
          font-size: 28px;
          font-weight: 500;
          background: rgba(15,15,47,0.04);
          &.upload{
            border: none;
          }
          & ~ .btn{
            margin-left: 20px;
            color: #fff;
            background: #17161C;
          }

          ::v-deep .van-uploader__wrapper {
            flex: 1;
            justify-content: center;
            .van-uploader__input-wrapper{
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.id-card-upload {
  padding-top: 62px;
  padding-bottom: 180px;
  box-sizing: border-box;
  min-height: 100%;
  .step-box {
    padding-top: 14px;

    .title {
      color: #17161c;
      font-size: 36px;
      font-weight: 500;
      line-height: 88px;
      padding: 0 32px;
      border-bottom: #f3f3f3 solid 1px;
    }

    .upload-box {
      display: flex;
      padding: 32px 32px 0;
      &.ani {
        @keyframes borderAni {
          0%,
          50%,
          100% {
            border-color: rgba(23, 22, 28, 0.45);
          }
          25%,
          75% {
            border-color: #fd2626;
          }
        }
        .upload {
          animation: borderAni 1s ease both;
        }
      }
      .item {
        flex: 1;
        position: relative;
        display: flex;
        .mask {
          position: absolute;
          z-index: 9;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }

        & ~ .item {
          margin-left: 24px;
        }
        .upload {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .tips-box {
    margin-top: 25px;
    padding: 0 32px;
    line-height: 48px;

    .title {
      font-size: 32px;
      font-weight: 500;
      color: #17161c;
      padding: 0;
      border: none;
      line-height: 50px;
    }

    .text {
      font-size: 28px;
      color: #747377;
      span {
        color: #f24e1e;
      }
    }
  }

  .eg-box {
    margin-top: 28px;
    padding: 0 32px;

    .title {
      font-size: 28px;
      font-weight: 500;
      color: #17161c;
      padding: 0;
      border: none;
      line-height: 50px;
    }

    .list {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 15px;
      .item {
        width: 156px;
        display: flex;
        flex-direction: column;
        .icon {
          height: 124px;
          min-height: 124px;
          max-height: 124px;
          width: 156px;
          object-fit: contain;
        }

        .text {
          text-align: center;
          margin-top: 10px;
          color: #747377;
          font-size: 24px;
        }
      }
    }
  }
}
.upload-img-error{
  ::v-deep {
    .van-dialog__header{
      font-size: 36px;
      font-weight: 600;
    }
    .van-dialog__content .van-dialog__message{
      color: #747377;
      line-height: 48px;
      font-size: 32px;
      padding-top: 32px;
    }
    .van-dialog__footer{
      padding: 0 56px 56px;
      &:after{
        display: none;
      }
      .van-button{
        background: rgba(15,15,47,0.04);
        height: 104px;
        border-radius: 104px;
        color: #17161C;
        font-size: 28px;
        font-weight: 500;
        & ~ .van-button{
          margin-left: 24px;
          background: #17161C;
          color: #fff;
        }
        &:after{
          display: none;
        }
      }
    }
  }
}

.black-theme{
  .id-card-upload{
    .step-box{
      .title{
        color: #fff;
        border-color: rgba(50,52,66,.5);
      }
      .upload-box{
        &.ani {
          @keyframes borderAni2 {
            0%,
            50%,
            100% {
              border-color: rgba(255,255,255,0.6);
            }
            25%,
            75% {
              border-color: #fd2626;
            }
          }
          .upload {
            animation: borderAni2 1s ease both;
          }
        }
      }
    }
    .tips-box{
      .title{
        color: #fff;
      }
      .text{
        color: #9D9D9F;
      }
    }
    .eg-box{
      .title{
        color: #fff;
      }
      .text {
        color: #9D9D9F !important;
      }
    }
  }
}
.darkOrLight{
  background: #1B1C24;
  &.is-error-popup{
    .tip{
      color: #fff;
    }
    .btn-box{
      .btn{
        background: #377CFB !important;
        &.upload{
          background: #8E92A3 !important;
          color: #fff !important;
          font-weight: 500;
        }
      }
    }

  }
  ::v-deep {

    .van-dialog__header{
      font-size: 36px;
      font-weight: 600;
      color: #FFFFFF;
    }
    .van-dialog__content .van-dialog__message{
      color: #747377;
      line-height: 48px;
      font-size: 32px;
      padding-top: 32px;
      color: #9D9D9F;
    }
    .van-dialog__footer{
      padding: 0 56px 56px;
      &:after{
        display: none;
      }
      .van-button{
        background: #8E92A3;
        height: 104px;
        border-radius: 104px;
        color: #FFFFFF;
        font-size: 28px;
        font-weight: 500;
        & ~ .van-button{
          margin-left: 24px;
          background: #377CFB;
          color: #fff;
        }
        &:after{
          display: none;
        }
      }
    }
  }
}
</style>
